import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MotesToggleComponent } from './motes-toggle.component';



@NgModule({
    declarations: [
        MotesToggleComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        MotesToggleComponent
    ]
})
export class MotesToggleModule { }
